import React, { useState } from 'react'
 
 
import RateCardList from './RateCardList';
import RateCardForm from './RateCardForm';

const RateCard= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <RateCardForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <RateCardList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default RateCard